// extracted by extract-css-chunks-webpack-plugin
module.exports = {"overlay":"OrderHelpTemplateLoading-855fc14d7d871a07","background-circle":"OrderHelpTemplateLoading-937ee8b4789a39c7"};